<template>

    <div class="">
        <div v-if="expenseCount > 0">
            <div v-for="(movement, index) in compSortedMovements" :key="index">
                <AdminBlock v-if="movement.expenses.length > 0" :title="'Movement ' + movement.position + ' - ' + movement.collection_locale + ' to ' + movement.delivery_locale">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 175px;">Recharge Client</th>
                                <th style="width: 50px;">#</th>
                                <th style="width:200px;">Driver</th>
                                <th style="width:250px">Label</th>
                                <th style="width:400px">Total</th>
                                <th>Evidence Received</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr v-for="(expense, index) in movement.expenses" :key="index">
                                <td class="align-middle">
                                    <input
                                        type="checkbox"
                                        :data-expense-id="expense.id"
                                        v-model="expense.recharge_client"
                                        @click="updateRechargeClient($event, expense.id)"
                                    >
                                </td>
                                <td class="align-middle">
                                    <a :href="generateExpenseUrl(expense)">
                                        {{ expense.id }}
                                    </a>
                                </td>
                                <td class="align-middle">
                                    <a v-if="expense.driver" :href="generateDriverUrl(expense.driver)">
                                        {{ expense.driver.name }}
                                    </a>
                                    <p v-else class="mb-0">
                                        Not Set
                                    </p>
                                </td>
                                <td class="align-middle">
                                    {{ expense.label }}
                                </td>
                                <td class="align-middle">
                                    {{ expense.formatted_total }}
                                </td>
                                <td class="align-middle">
                                    {{ expenseStatus(expense) }}
                                </td>
                                <td class="align-middle" style="width: 200px;">
                                    <button
                                        class="btn btn-sm btn-danger"
                                        style="width: 130px;"
                                        @click.prevent="deleteExpense(expense.id)"
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </AdminBlock>
            </div>

            <div class="row">
                    <div class="col-6">
                        <AdminBlock>

                            <p>Expenses listed above could include any of the following:</p>

                            <div class="row">
                                <div class="col-sm-3">
                                    <ul>
                                        <li>Bus</li>
                                        <li>Car Wash</li>
                                        <li>Oil</li>
                                        <li>Storage</li>
                                    </ul>
                                </div>
                                <div class="col-sm-3">
                                    <ul>
                                        <li>Misc</li>
                                        <li>Taxi</li>
                                        <li>Train</li>
                                        <li>Weekend Rate</li>
                                    </ul>
                                </div>
                            </div>

                        </AdminBlock>
                    </div>
                    <div class="col-6">
                        <AdminBlock>

                            <p>
                                If you want to add one of the following expenses, please do that on the next step:
                            </p>

                            <div class="row">
                                <div class="col-sm-3">
                                    <ul>
                                        <li>Waiting Time</li>
                                        <li>Weekend Rate</li>
                                        <li>Vehicle Breakdown</li>
                                        <li>Night Out</li>
                                    </ul>
                                </div>
                                <div class="col-sm-3">
                                    <ul>
                                        <li>AD Blue</li>
                                        <li>Bridge and Road Tolls</li>
                                        <li>Misc</li>
                                    </ul>
                                </div>
                            </div>

                        </AdminBlock>
                    </div>
                </div>
        </div>

        <div v-else>
            <div class="row">
                <div class="col-12 ">
                    <AdminBlock>
                        <p class="text-center mb-0">
                            <em>There are no Expenses in this Job</em>
                        </p>
                    </AdminBlock>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 ">
                <AdminBlock>
                    <div class="d-flex justify-content-between">
                        <div class="d-flex">

                            <div class="">

                                <button
                                    type="button"
                                    class="btn btn-secondary btn-sm me-2"
                                    @click="modals.expense.show()"
                                >
                                    Add Expense
                                </button>

                                <ExpenseModal
                                    identifier="signoff"
                                    :movements="movements"
                                    :job="job"
                                    @expense-created="fetchExpenses"
                                />

                                <ExpenseModal
                                    identifier="update"
                                    :movements="movements"
                                    :job="job"
                                    :expense="selectedExpense"
                                    :is-edit="true"
                                    @expense-created="fetchExpenses"
                                />

                            </div>

                            <div class="">

                                <button
                                    type="button"
                                    class="btn btn-sm btn-secondary"
                                    @click="modals.fuel.show()"
                                >
                                    Add Fuel
                                </button>

                                <FuelModal
                                    identifier="expense"
                                    :movements="movements"
                                    :job="job"
                                    @fuel-created="fetchExpenses"
                                />

                            </div>

                        </div>

                        <div class="">
                            <a :href="generateBackUrl()" class="btn btn-sm btn-danger me-2">
                                Back
                            </a>
                            <a :href="generateProceedUrl()" class="btn btn-sm btn-success">
                                Proceed
                            </a>
                        </div>

                    </div>
                </AdminBlock>
            </div>
        </div>
    </div>

</template>

<script setup>

    import axios from "axios";
    import Modal from 'bootstrap/js/dist/modal';
    import Swal from "sweetalert2";
    import { computed, nextTick, onMounted, ref } from "vue";
    import AdminBlock from '@/components/movements/components/AdminBlock.vue';
    import ExpenseModal from "@/components/movements/components/ExpenseModal.vue";
    import FuelModal from "@/components/movements/components/FuelModal.vue";

    const emit = defineEmits(['expense-created']);

    const props = defineProps({
        job: {
            type: Object,
            required: true,
        },
        movements: {
            type: Array,
            required: true,
            default: () => [],
        },
    });

    const selectedExpense = ref(null);

    const movements = ref(props.movements);

    const rate = ref(null);
    const rate_information = ref(null);

    const modals = ref({});

    onMounted(() => {
        modals.value = {
            expense: new Modal(document.getElementById('signoff_expense_modal')),
            updateExpense: new Modal(document.getElementById('update_expense_modal')),
            fuel: new Modal(document.getElementById('expense_fuel_modal'))
        };
    });

    const generateDriverUrl = (driver) => {
        if (!driver) return '#';
        return route('movements.drivers.show', driver);
    };

    const generateExpenseUrl = (expense) => {
        return route('movements.jobs.expenses.show', expense);
    };

    const generateFetchExpensesUrl = () => {
        return route('api.movements.jobs.expenses.fetch', { job: props.job.id });
    };

    const generateBackUrl = () => {
        return route('movements.jobs.signoff', { job: props.job.id });
    };

    const generateProceedUrl = () => {
        return route('movements.jobs.signoff.confirmation', { job: props.job.id });
    };

    const fetchExpenses = async () => {
        try {
            const response = await axios.get(generateFetchExpensesUrl());
            movements.value = response.data.data;
        } catch (error) {
            await Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to load expenses',
                showConfirmButton: false,
                timer: 3000
            });
        }
    };

    const deleteExpense = (expenseId) => {

        Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            confirmButtonText: 'Delete',
            confirmButtonColor: '#65A30D',
            showCancelButton: true,
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(route('api.movements.expenses.destroy', { expense: expenseId }))
                    .then(response => {
                        fetchExpenses();
                        Swal.fire({
                            toast: true,
                            width: '400px',
                            position: 'top-end',
                            icon: 'success',
                            title: 'Expense Deleted',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    })
                    .catch(error => {

                        const errorMessages = error.response?.data?.errors || {};
                        const allErrors = Object.values(errorMessages)
                            .flat()
                            .map(msg => `<p class="mb-0">${msg}</p>`)
                            .join('');

                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'error',
                            title: "Error Deleting Expense",
                            html: allErrors || 'An error occurred',
                            timer: 3000,
                            showConfirmButton: false,
                        });
                    });
            }
        });
    };

    const updateRechargeClient = (event, expenseId) => {

        const data = new FormData();

        data.append('recharge_client', Boolean( event.target.checked ) );

        axios.post( route('api.movements.expenses.recharge_client.update', { expense: expenseId } ), data )
            .then(response => {
                Swal.fire({
                    toast: true,
                    width: '400px',
                    position: 'top-end',
                    icon: 'success',
                    title: 'Recharge Client Updated',
                    showConfirmButton: false,
                    timer: 1500
                });

                nextTick(() => {
                    fetchExpenses();
                });
            })
            .catch(error => {
                console.error(error);
            });

    };

    const expenseCount = computed(() => {
        if (!movements.value?.length) return 0;

        const movementsArray = Array.isArray(movements.value)
            ? movements.value
            : Object.values(movements.value);

        return movementsArray.reduce((count, movement) =>
            count + (movement.expenses?.length || 0), 0);
    });

    const expenseStatus = (expense) => {
        if (!expense?.driver) return 'N/A';
        return expense.evidence_received ? 'Yes' : 'No';
    };

    const compSortedMovements = computed(() => {

        if (!movements.value || movements.value.length === 0) {
            return [];
        }

        let movementsArray = Array.isArray(movements.value) ? movements.value : Object.values(movements.value);

        return movementsArray.sort((a, b) => a.position - b.position);
    });

</script>
